import { render, staticRenderFns } from "./GridName.vue?vue&type=template&id=5c80cc74&scoped=true&"
import script from "./GridName.vue?vue&type=script&lang=js&"
export * from "./GridName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c80cc74",
  null
  
)

export default component.exports